import {useState} from "react";
import useAxios from "axios-hooks";
import DeleteConfirmationDialog from "../../../Util/DeleteConfirmationDialog";

const DeleteCourseModal = ({
  showModal,
  toggleShowModal,
  onDelete,
  courseId,
  setErrorMsg,
  setShowError,
  setShowSuccess,
  courseTitle,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [{ loading }, executeDelete] = useAxios(
    {
      method: "delete",
      url: `/courses/${courseId}`,
    },
    { manual: true }
  );

  const handleDelete = async () => {
    try {
      const response = await executeDelete();
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        setShowSuccess?.(true);
        setTimeout(() => {
          setShowSuccess?.(false);
          window.location.reload();
        }, 2000);
        return true;
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message || error?.response?.data || error?.message;
      const resolvedMessage =
        apiMessage || "Unable to delete this course. Please try again.";

      setErrorMessage(resolvedMessage);
      setShowError?.(true);
      setErrorMsg?.(resolvedMessage);
    }

    return false;
  };

  const expectedValue = courseTitle ||"delete";

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={handleDelete}
      resourceName={courseTitle}
      resourceType="course"
      confirmationValue={expectedValue}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteCourseModal;